import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
	TextField,
	Typography,
	Grid,
	Button,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import Layout from "../../components/Wrappers/Layout";
import BlockIcon from "@mui/icons-material/Block";
import SaveIcon from "@mui/icons-material/Save";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { Card } from "reactstrap";
import { IoMdSend } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Alert } from "reactstrap";
import { getBlockUnblockCountry } from "../../redux/actions/blockUnblockCountryAction";
import { countries } from "../../utils/countriesDropdown";
import { getUpdateRiskList } from "../../redux/actions/updateRiskRulesAction";
import { IoMdSave } from "react-icons/io";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const SLSendLimit = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [show, setShow] = useState(true);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const [user, setUser] = useState({
		operation: "",
		blockBy: "",
		country: "",
		memberID: ""
	});

	const { operation, blockBy, country, memberID } = user;

	const onInputChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
		// console.log(setUser);
	};

	// BlockUnblockCountry

	const BlockUnblockCountry = () => {
		if ((operation, blockBy, country, memberID === "")) {
			alert("Please Insert Required Feilds");
		}
		setShow(false);
		const Req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				action: "BLOCK",
				customerId: memberID,
				operationName: operation,
				blockBy: blockBy,
				countryList: country
			}
		};

		return dispatch(getBlockUnblockCountry(Req, authToken));
	};

	const blockUnblockCountry = useSelector(
		({ blockUnblockCountry }) => blockUnblockCountry
	);
	// console.log("blockUnblockCountry", blockUnblockCountry);

	const getAllWalletsListRes = useSelector(
		({ riskRulesList }) => riskRulesList
	);

	// Limit
	var limit =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.limit;
		});

	// console.log("limit", limit);

	// riskScore

	var riskScore =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.riskScore;
		});

	// console.log("riskScore", riskScore);

	// ruleId

	var ruleId =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.ruleId;
		});

	// console.log("ruleId", ruleId);

	// ruleName

	var ruleName =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.ruleName;
		});
	// console.log("ruleName", ruleName);

	// ruleStatus

	var ruleStatus =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.ruleStatus;
		});

	// console.log("ruleStatus", ruleStatus);

	// getupdateRiskRule

	const getupdateRiskRule = () => {
		const Req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			riskRuleList: [
				{
					limit: limit,
					riskScore: riskScore,
					ruleId: ruleId,
					ruleName: ruleName,
					ruleStatus: ruleStatus
				}
			]
		};
		if (updateRiskRule.success) {
			swalWithBootstrapButtons.fire({
				type: "success",
				title: "Record Udated SuccessFully"
			});
		}

		return dispatch(getUpdateRiskList(Req, authToken));
	};

	const updateRiskRule = useSelector(({ updateRiskRule }) => updateRiskRule);
	// console.log("updateRiskRule", updateRiskRule);

	return (
		<>
			<Layout>
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}>
							{/* <Button
                onClick={IndividualE}
                startIcon={<IoIosArrowBack />}
                variant="text"
                color="primary"
              >
                Go Back
              </Button> */}
						</Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>

					{/* <hr /> */}
					<br />
					<br />
					<Grid container>
						<Grid item lg={12} md={12} sm={12}>
							<h6
								align="center"
								className="text-center themeText"
								// style={{ marginTop: "1.2rem", marginRight: "3rem" }}
							>
								{" "}
								Block Country
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }}>
								<Typography
									className="themeText"
									variant="body1"
									align="justify"
									gutterBottom={true}
								>
									*Operation:
								</Typography>
								<TextField
									select
									size="small"
									color="primary"
									autoFocus={true}
									// label="role"
									variant="outlined"
									fullWidth={true}
									name="operation"
									value={operation}
									onChange={(e) => onInputChange(e)}
								>
									<MenuItem value="Redeem">Redeem</MenuItem>
									<MenuItem value="Purchase">Purchase</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<Typography variant="body1" align="justify" gutterBottom={true}>
									*Block By:
								</Typography>
								<TextField
									select
									size="small"
									color="primary"
									autoFocus={true}
									// label="role"
									variant="outlined"
									fullWidth={true}
									name="blockBy"
									value={blockBy}
									onChange={(e) => onInputChange(e)}
								>
									<MenuItem value="IP-Country">IP-Country</MenuItem>
									<MenuItem value="BIN-Country">BIN-Country</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<Typography variant="body1" align="justify" gutterBottom={true}>
									*Country:
								</Typography>
								<TextField
									select
									size="small"
									color="primary"
									autoFocus={true}
									// label="role"
									variant="outlined"
									fullWidth={true}
									name="country"
									value={country}
									onChange={(e) => onInputChange(e)}
								>
									{/* {countries.map((value) => (
                    <MenuItem value={value.label}>{value.label}</MenuItem>
                  ))} */}

									<MenuItem value="AF|AFG|093|Afghanistan">
										Afghanistan
									</MenuItem>
									<MenuItem value="AX|ALA|358|Aland Islands">
										Aland Islands
									</MenuItem>
									<MenuItem value="AL|ALB|355|Albania">Albania</MenuItem>
									<MenuItem value="DZ|DZA|231|Algeria">Algeria</MenuItem>
									<MenuItem value="AS|ASM|684|American Samoa">
										American Samoa
									</MenuItem>
									<MenuItem value="AD|AND|376|Andorra">Andorra</MenuItem>
									<MenuItem value="AO|AGO|244|Angola">Angola</MenuItem>
									<MenuItem value="AI|AIA|001|Anguilla">Anguilla</MenuItem>
									<MenuItem value="AQ|ATA|000|Antarctica">Antarctica</MenuItem>
									<MenuItem value="AG|ATG|001|Antigua and Barbuda">
										Antigua and Barbuda
									</MenuItem>
									<MenuItem value="AR|ARG|054|Argentina">Argentina</MenuItem>
									<MenuItem value="AM|ARM|374|Armenia">Armenia</MenuItem>
									<MenuItem value="AW|ABW|297|Aruba">Aruba</MenuItem>
									<MenuItem value="AU|AUS|061|Australia">Australia</MenuItem>
									<MenuItem value="AT|AUT|043|Austria">Austria</MenuItem>
									<MenuItem value="AZ|AZE|994|Azerbaijan">Azerbaijan</MenuItem>
									<MenuItem value="BS|BHS|001|Bahamas">Bahamas</MenuItem>
									<MenuItem value="BH|BHR|973|Bahrain">Bahrain</MenuItem>
									<MenuItem value="BD|BGD|880|Bangladesh">Bangladesh</MenuItem>
									<MenuItem value="BB|BRB|001|Barbados">Barbados</MenuItem>
									<MenuItem value="BY|BLR|375|Belarus">Belarus</MenuItem>
									<MenuItem value="BE|BEL|032|Belgium">Belgium</MenuItem>
									<MenuItem value="BZ|BLZ|501|Belize">Belize</MenuItem>
									<MenuItem value="BJ|BEN|229|Benin">Benin</MenuItem>
									<MenuItem value="BM|BMU|001|Bermuda">Bermuda</MenuItem>
									<MenuItem value="BT|BTN|975|Bhutan">Bhutan</MenuItem>
									<MenuItem value="BO|BOL|591|Bolivia">Bolivia</MenuItem>
									<MenuItem value="BA|BIH|387|Bosnia and Herzegovina">
										Bosnia and Herzegovina
									</MenuItem>
									<MenuItem value="BW|BWA|267|Botswana">Botswana</MenuItem>
									<MenuItem value="BV|BVT|000|Bouvet Island">
										Bouvet Island
									</MenuItem>
									<MenuItem value="BR|BRA|055|Brazil">Brazil</MenuItem>
									<MenuItem value="IO|IOT|246|British Indian Ocean Territory">
										British Indian Ocean Territory
									</MenuItem>
									<MenuItem value="VG|VGB|001|British Virgin Islands">
										British Virgin Islands
									</MenuItem>
									<MenuItem value="BN|BRN|673|Brunei">Brunei</MenuItem>
									<MenuItem value="BG|BGR|359|Bulgaria">Bulgaria</MenuItem>
									<MenuItem value="BF|BFA|226|Burkina Faso">
										Burkina Faso
									</MenuItem>
									<MenuItem value="BU|BUR|104|Burma">Burma</MenuItem>
									<MenuItem value="BI|BDI|257|Burundi">Burundi</MenuItem>
									<MenuItem value="KH|KHM|855|Cambodia">Cambodia</MenuItem>
									<MenuItem value="CM|CMR|237|Cameroon">Cameroon</MenuItem>
									<MenuItem value="CA|CAN|001|Canada">Canada</MenuItem>
									<MenuItem value="CV|CPV|238|Cape Verde">Cape Verde</MenuItem>
									<MenuItem value="KY|CYM|001|Cayman Islands">
										Cayman Islands
									</MenuItem>
									<MenuItem value="CF|CAF|236|Central African Republic">
										Central African Republic
									</MenuItem>
									<MenuItem value="TD|TCD|235|Chad">Chad</MenuItem>
									<MenuItem value="CL|CHL|056|Chile">Chile</MenuItem>
									<MenuItem value="CN|CHN|086|China">China</MenuItem>
									<MenuItem value="CX|CXR|061|Christmas Island">
										Christmas Island
									</MenuItem>
									<MenuItem value="CC|CCK|061|Cocos (Keeling) Islands">
										Cocos (Keeling) Islands
									</MenuItem>
									<MenuItem value="CO|COL|057|Colombia">Colombia</MenuItem>
									<MenuItem value="KM|COM|269|Comoros">Comoros</MenuItem>
									<MenuItem value="CK|COK|682|Cook Islands">
										Cook Islands
									</MenuItem>
									<MenuItem value="CR|CRI|506|Costa Rica">Costa Rica</MenuItem>
									<MenuItem value="CI|CIV|225|Cote d'Ivoire">
										Cote d'Ivoire
									</MenuItem>
									<MenuItem value="HR|HRV|385|Croatia">Croatia</MenuItem>
									<MenuItem value="CU|CUB|053|Cuba">Cuba</MenuItem>
									<MenuItem value="CY|CYP|357|Cyprus">Cyprus</MenuItem>
									<MenuItem value="CZ|CZE|420|Czech Republic">
										Czech Republic
									</MenuItem>
									<MenuItem value="CD|COD|243|Democratic Republic of the Congo">
										Democratic Republic of the Congo
									</MenuItem>
									<MenuItem value="DK|DNK|045|Denmark">Denmark</MenuItem>
									<MenuItem value="DJ|DJI|253|Djibouti">Djibouti</MenuItem>
									<MenuItem value="DM|DMA|001|Dominica">Dominica</MenuItem>
									<MenuItem value="DO|DOM|001|Dominican Republic">
										Dominican Republic
									</MenuItem>
									<MenuItem value="EC|ECU|593|Ecuador">Ecuador</MenuItem>
									<MenuItem value="EG|EGY|020|Egypt">Egypt</MenuItem>
									<MenuItem value="SV|SLV|503|El Salvador">
										El Salvador
									</MenuItem>
									<MenuItem value="GQ|GNQ|240|Equatorial Guinea">
										Equatorial Guinea
									</MenuItem>
									<MenuItem value="ER|ERI|291|Eritrea">Eritrea</MenuItem>
									<MenuItem value="EE|EST|372|Estonia">Estonia</MenuItem>
									<MenuItem value="ET|ETH|251|Ethiopia">Ethiopia</MenuItem>
									<MenuItem value="FK|FLK|500|Falkland Islands">
										Falkland Islands
									</MenuItem>
									<MenuItem value="FO|FRO|298|Faroe Islands">
										Faroe Islands
									</MenuItem>
									<MenuItem value="FJ|FJI|679|Fiji">Fiji</MenuItem>
									<MenuItem value="FI|FIN|358|Finland">Finland</MenuItem>
									<MenuItem value="FR|FRA|033|France">France</MenuItem>
									<MenuItem value="GF|GUF|594|French Guiana">
										French Guiana
									</MenuItem>
									<MenuItem value="PF|PYF|689|French Polynesia">
										French Polynesia
									</MenuItem>
									<MenuItem value="TF|ATF|000|French Southern and Antarctic Lands">
										French Southern and Antarctic Lands
									</MenuItem>
									<MenuItem value="GA|GAB|241|Gabon">Gabon</MenuItem>
									<MenuItem value="GM|GMB|220|Gambia">Gambia</MenuItem>
									<MenuItem value="GE|GEO|995|Georgia">Georgia</MenuItem>
									<MenuItem value="DE|DEU|049|Germany">Germany</MenuItem>
									<MenuItem value="GH|GHA|233|Ghana">Ghana</MenuItem>
									<MenuItem value="GI|GIB|350|Gibraltar">Gibraltar</MenuItem>
									<MenuItem value="GR|GRC|030|Greece">Greece</MenuItem>
									<MenuItem value="GL|GRL|299|Greenland">Greenland</MenuItem>
									<MenuItem value="GD|GRD|001|Grenada">Grenada</MenuItem>
									<MenuItem value="GP|GLP|590|Guadeloupe">Guadeloupe</MenuItem>
									<MenuItem value="GU|GUM|001|Guam">Guam</MenuItem>
									<MenuItem value="GT|GTM|502|Guatemala">Guatemala</MenuItem>
									<MenuItem value="GG|GGY|000|Guernsey">Guernsey</MenuItem>
									<MenuItem value="GN|GIN|224|Guinea">Guinea</MenuItem>
									<MenuItem value="GW|GNB|245|Guinea-Bissau">
										Guinea-Bissau
									</MenuItem>
									<MenuItem value="GY|GUY|592|Guyana">Guyana</MenuItem>
									<MenuItem value="HT|HTI|509|Haiti">Haiti</MenuItem>
									<MenuItem value="HM|HMD|672|Heard Island & McDonald Islands">
										Heard Island & McDonald Islands
									</MenuItem>
									<MenuItem value="HN|HND|504|Honduras">Honduras</MenuItem>
									<MenuItem value="HK|HKG|852|Hong Kong">Hong Kong</MenuItem>
									<MenuItem value="HU|HUN|036|Hungary">Hungary</MenuItem>
									<MenuItem value="IS|ISL|354|Iceland">Iceland</MenuItem>
									<MenuItem value="IN|IND|091|India">India</MenuItem>
									<MenuItem value="ID|IDN|062|Indonesia">Indonesia</MenuItem>
									<MenuItem value="IR|IRN|098|Iran">Iran</MenuItem>
									<MenuItem value="IQ|IRQ|964|Iraq">Iraq</MenuItem>
									<MenuItem value="IE|IRL|353|Ireland">Ireland</MenuItem>
									<MenuItem value="IL|ISR|972|Israel">Israel</MenuItem>
									<MenuItem value="IT|ITA|039|Italy">Italy</MenuItem>
									<MenuItem value="JM|JAM|001|Jamaica">Jamaica</MenuItem>
									<MenuItem value="JP|JPN|081|Japan">Japan</MenuItem>
									<MenuItem value="JE|JEY|044|Jersey">Jersey</MenuItem>
									<MenuItem value="JO|JOR|962|Jordan">Jordan</MenuItem>
									<MenuItem value="KZ|KAZ|007|Kazakhstan">Kazakhstan</MenuItem>
									<MenuItem value="KE|KEN|254|Kenya">Kenya</MenuItem>
									<MenuItem value="KI|KIR|686|Kiribati">Kiribati</MenuItem>
									<MenuItem value="KW|KWT|965|Kuwait">Kuwait</MenuItem>
									<MenuItem value="KG|KGZ|996|Kyrgyzstan">Kyrgyzstan</MenuItem>
									<MenuItem value="LA|LAO|856|Laos">Laos</MenuItem>
									<MenuItem value="LV|LVA|371|Latvia">Latvia</MenuItem>
									<MenuItem value="LB|LBN|961|Lebanon">Lebanon</MenuItem>
									<MenuItem value="LS|LSO|266|Lesotho">Lesotho</MenuItem>
									<MenuItem value="LR|LBR|231|Liberia">Liberia</MenuItem>
									<MenuItem value="LY|LBY|218|Libya">Libya</MenuItem>
									<MenuItem value="LI|LIE|423|Liechtenstein">
										Liechtenstein
									</MenuItem>
									<MenuItem value="LT|LTU|370|Lithuania">Lithuania</MenuItem>
									<MenuItem value="LU|LUX|352|Luxembourg">Luxembourg</MenuItem>
									<MenuItem value="MO|MAC|853|Macau, China">
										Macau, China
									</MenuItem>
									<MenuItem value="MK|MKD|389|Macedonia">Macedonia</MenuItem>
									<MenuItem value="MG|MDG|261|Madagascar">Madagascar</MenuItem>
									<MenuItem value="MW|MWI|265|Malawi">Malawi</MenuItem>
									<MenuItem value="MY|MYS|060|Malaysia">Malaysia</MenuItem>
									<MenuItem value="MV|MDV|960|Maldives">Maldives</MenuItem>
									<MenuItem value="ML|MLI|223|Mali">Mali</MenuItem>
									<MenuItem value="MT|MLT|356|Malta">Malta</MenuItem>
									<MenuItem value="MH|MHL|692|Marshall Islands">
										Marshall Islands
									</MenuItem>
									<MenuItem value="MQ|MTQ|596|Martinique">Martinique</MenuItem>
									<MenuItem value="MR|MRT|222|Mauritania">Mauritania</MenuItem>
									<MenuItem value="MU|MUS|230|Mauritius">Mauritius</MenuItem>
									<MenuItem value="YT|MYT|269|Mayotte">Mayotte</MenuItem>
									<MenuItem value="MX|MEX|052|Mexico">Mexico</MenuItem>
									<MenuItem value="FM|FSM|691|Micronesia, Federated States of">
										Micronesia, Federated States of
									</MenuItem>
									<MenuItem value="MD|MDA|373|Moldova">Moldova</MenuItem>
									<MenuItem value="MC|MCO|377|Monaco">Monaco</MenuItem>
									<MenuItem value="MN|MNG|976|Mongolia">Mongolia</MenuItem>
									<MenuItem value="ME|MNE|382|Montenegro">Montenegro</MenuItem>
									<MenuItem value="MS|MSR|001|Montserrat">Montserrat</MenuItem>
									<MenuItem value="MA|MAR|212|Morocco">Morocco</MenuItem>
									<MenuItem value="MZ|MOZ|258|Mozambique">Mozambique</MenuItem>
									<MenuItem value="MM|MMR|095|Myanmar">Myanmar</MenuItem>
									<MenuItem value="NA|NAM|264|Namibia">Namibia</MenuItem>
									<MenuItem value="NR|NRU|674|Nauru">Nauru</MenuItem>
									<MenuItem value="NP|NPL|977|Nepal">Nepal</MenuItem>
									<MenuItem value="AN|ANT|599|Netherlands Antilles">
										Netherlands Antilles
									</MenuItem>
									<MenuItem value="NL|NLD|031|Netherlands">
										Netherlands
									</MenuItem>
									<MenuItem value="NC|NCL|687|New Caledonia">
										New Caledonia
									</MenuItem>
									<MenuItem value="NZ|NZL|064|New Zealand">
										New Zealand
									</MenuItem>
									<MenuItem value="NI|NIC|505|Nicaragua">Nicaragua</MenuItem>
									<MenuItem value="NE|NER|227|Niger">Niger</MenuItem>
									<MenuItem value="NG|NGA|234|Nigeria">Nigeria</MenuItem>
									<MenuItem value="NU|NIU|683|Niue">Niue</MenuItem>
									<MenuItem value="NF|NFK|672|Norfolk Island">
										Norfolk Island
									</MenuItem>
									<MenuItem value="KP|PRK|850|North Korea">
										North Korea
									</MenuItem>
									<MenuItem value="MP|MNP|001|Northern Mariana Islands">
										Northern Mariana Islands
									</MenuItem>
									<MenuItem value="NO|NOR|047|Norway">Norway</MenuItem>
									<MenuItem value="OM|OMN|968|Oman">Oman</MenuItem>
									<MenuItem value="PK|PAK|092|Pakistan">Pakistan</MenuItem>
									<MenuItem value="PW|PLW|680|Palau">Palau</MenuItem>
									<MenuItem value="PS|PSE|970|Palestinian Authority">
										Palestinian Authority
									</MenuItem>
									<MenuItem value="PA|PAN|507|Panama">Panama</MenuItem>
									<MenuItem value="PG|PNG|675|Papua New Guinea">
										Papua New Guinea
									</MenuItem>
									<MenuItem value="PY|PRY|595|Paraguay">Paraguay</MenuItem>
									<MenuItem value="PE|PER|051|Peru">Peru</MenuItem>
									<MenuItem value="PH|PHL|063|Philippines">
										Philippines
									</MenuItem>
									<MenuItem value="PN|PCN|064|Pitcairn Islands">
										Pitcairn Islands
									</MenuItem>
									<MenuItem value="PL|POL|048|Poland">Poland</MenuItem>
									<MenuItem value="PT|PRT|351|Portugal">Portugal</MenuItem>
									<MenuItem value="PR|PRI|001|Puerto Rico">
										Puerto Rico
									</MenuItem>
									<MenuItem value="QA|QAT|974|Qatar">Qatar</MenuItem>
									<MenuItem value="CG|COD|242|Republic of the Congo">
										Republic of the Congo
									</MenuItem>
									<MenuItem value="RE|REU|262|Reunion">Reunion</MenuItem>
									<MenuItem value="RO|ROU|040|Romania">Romania</MenuItem>
									<MenuItem value="RU|RUS|007|Russia">Russia</MenuItem>
									<MenuItem value="RW|RWA|250|Rwanda">Rwanda</MenuItem>
									<MenuItem value="BL|BLM|590|Saint Barthelemy">
										Saint Barthelemy
									</MenuItem>
									<MenuItem value="SH|SHN|290|Saint Helena, Ascension & Tristan daCunha">
										Saint Helena, Ascension & Tristan daCunha
									</MenuItem>
									<MenuItem value="KN|KNA|001|Saint Kitts and Nevis">
										Saint Kitts and Nevis
									</MenuItem>
									<MenuItem value="LC|LCA|001|Saint Lucia">
										Saint Lucia
									</MenuItem>
									<MenuItem value="MF|MAF|590|Saint Martin">
										Saint Martin
									</MenuItem>
									<MenuItem value="PM|SPM|508|Saint Pierre and Miquelon">
										Saint Pierre and Miquelon
									</MenuItem>
									<MenuItem value="VC|VCT|001|Saint Vincent and Grenadines">
										Saint Vincent and Grenadines
									</MenuItem>
									<MenuItem value="WS|WSM|685|Samoa">Samoa</MenuItem>
									<MenuItem value="SM|SMR|378|San Marino">San Marino</MenuItem>
									<MenuItem value="ST|STP|239|Sao Tome and Principe">
										Sao Tome and Principe
									</MenuItem>
									<MenuItem value="SA|SAU|966|Saudi Arabia">
										Saudi Arabia
									</MenuItem>
									<MenuItem value="SN|SEN|221|Senegal">Senegal</MenuItem>
									<MenuItem value="RS|SRB|381|Serbia">Serbia</MenuItem>
									<MenuItem value="SC|SYC|248|Seychelles">Seychelles</MenuItem>
									<MenuItem value="SL|SLE|232|Sierra Leone">
										Sierra Leone
									</MenuItem>
									<MenuItem value="SG|SGP|065|Singapore">Singapore</MenuItem>
									<MenuItem value="SK|SVK|421|Slovakia">Slovakia</MenuItem>
									<MenuItem value="SI|SVN|386|Slovenia">Slovenia</MenuItem>
									<MenuItem value="SB|SLB|677|Solomon Islands">
										Solomon Islands
									</MenuItem>
									<MenuItem value="SO|SOM|252|Somalia">Somalia</MenuItem>
									<MenuItem value="ZA|ZAF|027|South Africa">
										South Africa
									</MenuItem>
									<MenuItem value="GS|SGS|000|South Georgia & South Sandwich Islands">
										South Georgia & South Sandwich Islands
									</MenuItem>
									<MenuItem value="KR|KOR|082|South Korea">
										South Korea
									</MenuItem>
									<MenuItem value="ES|ESP|034|Spain">Spain</MenuItem>
									<MenuItem value="LK|LKA|094|Sri Lanka">Sri Lanka</MenuItem>
									<MenuItem value="SD|SDN|249|Sudan">Sudan</MenuItem>
									<MenuItem value="SR|SUR|597|Suriname">Suriname</MenuItem>
									<MenuItem value="SJ|SJM|047|Svalbard and Jan Mayen">
										Svalbard and Jan Mayen
									</MenuItem>
									<MenuItem value="SZ|SWZ|268|Swaziland">Swaziland</MenuItem>
									<MenuItem value="SE|SWE|046|Sweden">Sweden</MenuItem>
									<MenuItem value="CH|CHE|041|Switzerland">
										Switzerland
									</MenuItem>
									<MenuItem value="SY|SYR|963|Syria">Syria</MenuItem>
									<MenuItem value="TW|TWN|886|Taiwan">Taiwan</MenuItem>
									<MenuItem value="TJ|TJK|992|Tajikistan">Tajikistan</MenuItem>
									<MenuItem value="TZ|TZA|255|Tanzania">Tanzania</MenuItem>
									<MenuItem value="TH|THA|066|Thailand">Thailand</MenuItem>
									<MenuItem value="TL|TLS|670|Timor-Leste">
										Timor-Leste
									</MenuItem>
									<MenuItem value="TG|TLS|228|Togo">Togo</MenuItem>
									<MenuItem value="TK|TKL|690|Tokelau">Tokelau</MenuItem>
									<MenuItem value="TO|TON|676|Tonga">Tonga</MenuItem>
									<MenuItem value="TT|TTO|001|Trinidad and Tobago">
										Trinidad and Tobago
									</MenuItem>
									<MenuItem value="TN|TUN|216|Tunisia">Tunisia</MenuItem>
									<MenuItem value="TR|TUR|090|Turkey">Turkey</MenuItem>
									<MenuItem value="TM|TKM|993|Turkmenistan">
										Turkmenistan
									</MenuItem>
									<MenuItem value="TC|TCA|001|Turks and Caicos Islands">
										Turks and Caicos Islands
									</MenuItem>
									<MenuItem value="TV|TUV|688|Tuvalu">Tuvalu</MenuItem>
									<MenuItem value="UG|UGA|256|Uganda">Uganda</MenuItem>
									<MenuItem value="UA|UKR|380|Ukraine">Ukraine</MenuItem>
									<MenuItem value="AE|ARE|971|United Arab Emirates">
										United Arab Emirates
									</MenuItem>
									<MenuItem value="GB|GBR|044|United Kingdom">
										United Kingdom
									</MenuItem>
									<MenuItem value="US|USA|001|United States">
										United States
									</MenuItem>
									<MenuItem value="VI|VIR|001|United States Virgin Islands">
										United States Virgin Islands
									</MenuItem>
									<MenuItem value="UY|URY|598|Uruguay">Uruguay</MenuItem>
									<MenuItem value="UZ|UZB|998|Uzbekistan">Uzbekistan</MenuItem>
									<MenuItem value="VU|VUT|678|Vanuatu">Vanuatu</MenuItem>
									<MenuItem value="VA|VAT|379|Vatican City">
										Vatican City
									</MenuItem>
									<MenuItem value="VE|VEN|058|Venezuela">Venezuela</MenuItem>
									<MenuItem value="VN|VNM|084|Vietnam">Vietnam</MenuItem>
									<MenuItem value="WF|WLF|681|Wallis and Futuna">
										Wallis and Futuna
									</MenuItem>
									<MenuItem value="EH|ESH|212|Western Sahara">
										Western Sahara
									</MenuItem>
									<MenuItem value="YE|YEM|967|Yemen">Yemen</MenuItem>
									<MenuItem value="ZM|ZMB|260|Zambia">Zambia</MenuItem>
									<MenuItem value="ZW|ZWE|263|Zimbabwe">Zimbabwe</MenuItem>
								</TextField>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<Typography
									className="themeText"
									variant="body1"
									align="justify"
									gutterBottom={true}
								>
									Member ID:
								</Typography>
								<TextField
									// type="text"
									required
									size="small"
									color="primary"
									autoFocus={true}
									// label="firstName"
									variant="outlined"
									fullWidth={true}
									name="memberID"
									value={memberID}
									onChange={(e) => onInputChange(e)}
								/>
							</div>

							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								{/* <Button
                  style={{
                    // marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  endIcon={<IoMdSend />}
                  variant="contained"
                  // color="primary"
                  onClick={BlockUnblockCountry}
                >
                  Block <BlockIcon />
                </Button>  */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={BlockUnblockCountry}
								>
									Block <BlockIcon />
								</CustomButton>
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>

				{show ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Typography className="themeText" variant="body1">
								{" "}
								Default Rule List
							</Typography>
							<Grid sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<TableContainer component={Paper}>
						<Table
							className={classes.table}
							size="small"
							aria-label="a dense table"
						>
							<TableHead>
								<TableRow className="tableHeaderColor">
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Rule ID{" "}
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Rule Name{" "}
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Risk Group
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Score
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Limit
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Status
									</TableCell>
									{/* <TableCell align="center">Action</TableCell> */}
								</TableRow>
							</TableHead>

							<TableBody>
								{getAllWalletsListRes.success &&
									getAllWalletsListRes.data.riskRuleList &&
									[]
										.concat(getAllWalletsListRes.data.riskRuleList)
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => (
											<TableRow key={row.ruleId}>
												<TableCell align="center">{row.ruleId}</TableCell>
												<TableCell align="center">{row.ruleName}</TableCell>
												<TableCell align="center">{row.riskGroup}</TableCell>
												<TableCell align="center">
													<TextField
														value={row.max_transaction_amount}
														size="small"
														color="primary"
														autoFocus={true}
														variant="outlined"
														fullWidth={true}
													>
														{" "}
														{row.max_transaction_amount}
													</TextField>
												</TableCell>
												<TableCell align="center">
													<TextField
														value={row.min_transaction_amount}
														size="small"
														color="primary"
														autoFocus={true}
														variant="outlined"
														fullWidth={true}
													>
														{row.min_transaction_amount}
													</TextField>
												</TableCell>
												<TableCell align="center">
													<TextField
														select
														size="small"
														color="primary"
														autoFocus={true}
														// label="role"
														variant="outlined"
														fullWidth={true}
														name="role"
														// value={role}
														// onChange={(e) => onInputChange(e)}
													>
														<MenuItem value="Enable">Enable</MenuItem>
														<MenuItem value="Disable">Disable</MenuItem>
													</TextField>
												</TableCell>
											</TableRow>
										))}
							</TableBody>
						</Table>

						<TablePagination
							rowsPerPageOptions={[5, 10, 25]}
							component="div"
							count={[].concat(getAllWalletsListRes.data.riskRuleList).length}
							rowsPerPage={rowsPerPage}
							page={page}
							onChangePage={handleChangePage}
							onChangeRowsPerPage={handleChangeRowsPerPage}
						/>
						<Grid container>
							<Grid item md={5} lg={5}></Grid>
							<Grid item md={2} lg={2}>
								{/* <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  size="small"
                  className="my-2"
                  endIcon={<IoMdSave />}
                  onClick={getupdateRiskRule}
                >
                  Save
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={getupdateRiskRule}
								>
									Save <SaveIcon />
								</CustomButton>
							</Grid>
							<Grid item md={5} lg={5}></Grid>
						</Grid>
					</TableContainer>
				)}
			</Layout>
		</>
	);
};

export default SLSendLimit;
